import React from "react";
import GetInTouch from "../../components/GetInTouch.js";
import VoipSolContact from "../../components/VoipSolContact.js";

const SmallBusinessVoipSolution = () => {
  return (
    <div className=" flex flex-col items-center justify-center p-6 mb-6">
      <div className="flex flex-col md:flex-row justify-between items-center md:items-start mb-4  ">
        <div className="md:w-2/3 space-y-6 p-4">
          <h1 className="sm:text-4xl md:text-5xl lg:text-6xl font-bold text-gray-800 mt-10">
            VoIP Solutions Tailored for Small Businesses
          </h1>
          <p className="text-gray-700 text-base lg:text-xl">
            Are you a small business owner searching for a communication system
            that is not only reliable but also scalable and cost-efficient? Our
            VoIP solutions are designed specifically to meet the dynamic needs
            of small businesses, providing a robust platform to enhance your
            operations. Whether you want to optimize internal communications,
            improve customer interactions, or stay ahead in a competitive
            market, our flexible VoIP services deliver unmatched performance and
            value. With advanced features, seamless connectivity, and
            customization options, we ensure your business remains agile,
            adaptable, and poised for growth in today’s ever-evolving landscape.
          </p>
        </div>

        <VoipSolContact />
      </div>

      <div className=" mb-5 p-4 w-full">
        <div className="flex flex-col lg:flex-row items-center lg:space-x-16">
          <div className="flex justify-center lg:w-1/4  lg:mb-0">
            <img
              src="/assets/images/headerSection/entVoip.webp"
              alt="VoIP Business Solutions"
              className="w-full h-auto sm:w-3/4 md:w-2/3 lg:w-full object-contain"
            />
          </div>

          <div className="lg:w-3/4  lg:text-left  mt-6">
            <h2 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800 mb-4">
              Small Business VoIP Explained
            </h2>
            <p className="sm:text-base md:text-lg lg:text-xl text-gray-600 leading-relaxed mb-3">
              Small businesses, like their larger counterparts, require
              efficient communication systems to deliver excellent customer
              service. VoIP solutions designed for small businesses provide a
              modern way to make voice calls, send text messages, and exchange
              SMS over the Internet.
              <br />
              <br />
              These solutions are tailored to improve call routing, optimize
              communication processes, and offer detailed insights into
              performance metrics. With minimal investment, small businesses can
              access high-end features such as IVR (Interactive Voice Response),
              automatic call forwarding, virtual receptionists, robust reporting
              tools, and seamless integration with existing business software.
            </p>
          </div>
        </div>
      </div>

      <div className="rounded-3xl">
        <div className="text-center mb-5 mt-5">
          <h2 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800">
            Key Features of Small Business VoIP
          </h2>
          <p className="sm:text-base md:text-lg lg:text-xl text-gray-600 font-semibold mt-4 max-w-6xl mx-auto">
            Ayanshtech offers a comprehensive VoIP solution that empowers small
            businesses with seamless communication and improved customer
            engagement. Below are some key features that can help your business
            thrive:
          </p>
        </div>

        <div className="p-4">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {/* Item 1 */}
            <div
              className="relative flex flex-col space-y-4  rounded-lg p-6"
              style={{
                boxShadow:
                  "0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 15px 4px rgba(59, 130, 246, 0.4), 0 0 15px 4px rgba(16, 185, 129, 0.4)",
              }}
            >
              <h3 className="text-lg font-bold">
                Audio & Video Conference Solutions
              </h3>
              <p className="text-lg">
                Enhance team collaboration and productivity with seamless audio
                and video conferencing. This feature ensures remote
                communication with high-quality video calls.
              </p>
            </div>

            {/* Item 2 */}
            <div
              className="relative flex flex-col space-y-4  rounded-lg p-6"
              style={{
                boxShadow:
                  "0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 15px 4px rgba(59, 130, 246, 0.4), 0 0 15px 4px rgba(16, 185, 129, 0.4)",
              }}
            >
              <h3 className="text-lg font-bold">Code Analytics</h3>
              <p className="text-lg">
                Gain valuable insights into your customer interactions with
                real-time call analytics. Track call session metrics, agent
                performance, and more to optimize your business operations.
              </p>
            </div>

            {/* Item 3 */}
            <div
              className="relative flex flex-col space-y-4  rounded-lg p-6"
              style={{
                boxShadow:
                  "0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 15px 4px rgba(59, 130, 246, 0.4), 0 0 15px 4px rgba(16, 185, 129, 0.4)",
              }}
            >
              <h3 className="text-lg font-bold">Call Forwarding</h3>
              <p className="text-lg">
                Stay connected no matter where you are. Forward calls to any
                device, ensuring you never miss important communications, even
                when away from the office.
              </p>
            </div>

            {/* Item 4 */}
            <div
              className="relative flex flex-col space-y-4  rounded-lg p-6"
              style={{
                boxShadow:
                  "0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 15px 4px rgba(59, 130, 246, 0.4), 0 0 15px 4px rgba(16, 185, 129, 0.4)",
              }}
            >
              <h3 className="text-lg font-bold">
                Interactive Voice Response (IVR)
              </h3>
              <p className="text-lg">
                Automate call handling with IVR, which directs callers to the
                right department or information, improving customer experience
                and reducing wait times.
              </p>
            </div>

            {/* Item 5 */}
            <div
              className="relative flex flex-col space-y-4  rounded-lg p-6"
              style={{
                boxShadow:
                  "0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 15px 4px rgba(59, 130, 246, 0.4), 0 0 15px 4px rgba(16, 185, 129, 0.4)",
              }}
            >
              <h3 className="text-lg font-bold">Auto Attendant</h3>
              <p className="text-lg">
                This feature allows you to efficiently manage incoming calls
                based on predefined rules, helping you route calls and provide a
                professional experience for callers.
              </p>
            </div>

            {/* Item 6 */}
            <div
              className="relative flex flex-col space-y-4  rounded-lg p-6"
              style={{
                boxShadow:
                  "0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 15px 4px rgba(59, 130, 246, 0.4), 0 0 15px 4px rgba(16, 185, 129, 0.4)",
              }}
            >
              <h3 className="text-lg font-bold">Easy Integration</h3>
              <p className="text-lg">
                Seamlessly integrate VoIP services with other business
                communication tools, streamlining operations and reducing the
                need for separate applications.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div>
        <div className="text-center mb-12 mt-5">
          <h2 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800">
            Why Select Ayanshtech as Your VoIP Enterprise Partner
          </h2>
        </div>

        <div className="grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-6 max-w-7xl mx-auto mb-20">
          <div className="flex items-center space-x-4">
            <img
              src="\assets\icons\techIcons\icon15.png"
              alt="icon"
              className="w-10 h-10"
            />
            <div>
              <p className="text-lg">
                We are a renowned VoIP solutions provider with numerous
                accolades to our name.
              </p>
            </div>
          </div>

          <div className="flex items-center space-x-4">
            <img
              src="\assets\icons\techIcons\icon16.png"
              alt="icon"
              className="w-10 h-10"
            />
            <div>
              <p className="text-lg">
                With over a decade of experience, our team of experts is
                well-versed in the technology behind VoIP solutions.
              </p>
            </div>
          </div>

          <div className="flex items-center space-x-4">
            <img
              src="\assets\icons\techIcons\icon17.png"
              alt="icon"
              className="w-10 h-10"
            />
            <div>
              <p className="text-lg">
                We take the time to truly understand your needs, offering
                solutions that align perfectly with your goals.
              </p>
            </div>
          </div>

          <div className="flex items-center space-x-4">
            <img
              src="\assets\icons\techIcons\icon18.png"
              alt="icon"
              className="w-10 h-10"
            />
            <div>
              <p className="text-lg">
                Our approach focuses on creating custom solutions, building
                everything from the ground up to suit your unique business
                requirements.
              </p>
            </div>
          </div>

          <div className="flex items-center space-x-4">
            <img
              src="\assets\icons\techIcons\icon19.png"
              alt="icon"
              className="w-10 h-10"
            />
            <div>
              <p className="text-lg">
                At Ayanshtech, we pride ourselves on punctuality, delivering
                projects on time while maintaining a high level of
                professionalism.
              </p>
            </div>
          </div>

          <div className="flex items-center space-x-4">
            <img
              src="\assets\icons\techIcons\icon20.png"
              alt="icon"
              className="w-10 h-10"
            />
            <div>
              <p className="text-lg">
                Our model focuses on providing cost-effective, high-quality
                solutions that rank among the best in the industry.
              </p>
            </div>
          </div>
        </div>
      </div>

      <GetInTouch />
    </div>
  );
};

export default SmallBusinessVoipSolution;
